import { fluid } from "../../../../assets/styles/functions/fluid";

export const style = {
  priceSeo: {
    paddingTop: fluid(7, 4),
    paddingBottom: fluid(7, 4),
  }
}
